import PropTypes from "prop-types";
import { Modal, Button } from "common-components";
import { UiModalTitle, StyledSendMail } from "./SendMailModal.style";

export const SendMailModal = ({ report, isLoading, onOk, onCancel }) => {
	const { CMS, contactEmail, isMailSent } = report;

	return (
		<Modal
			title={<UiModalTitle>確認寄送通知信</UiModalTitle>}
			visible={true}
			width="480px"
			onCancel={onCancel}
			footer={
				<>
					<Button variant="white" full={false} onClick={onCancel}>
						取消
					</Button>
					<Button variant="orange" full={false} loading={isLoading} disabled={!contactEmail} onClick={onOk}>
						確定
					</Button>
				</>
			}>
			<StyledSendMail>
				<div className="infoRow">
					<div className="infoLabel">CMS編號:</div>
					<div className="infoValue">{CMS}</div>
				</div>
				<div className="infoRow">
					<div className="infoLabel">收件信箱:</div>
					<div className="infoValue">{contactEmail || "未填寫"}</div>
				</div>
				{!contactEmail ? (
					<div className="warning">此筆回報未填寫聯絡信箱，無法寄送通知信</div>
				) : isMailSent ? (
					<div className="warning">此筆回報已寄送過通知信，確定要再寄一次嗎？</div>
				) : null}
			</StyledSendMail>
		</Modal>
	);
};

SendMailModal.propTypes = {
	report: PropTypes.object,
	isLoading: PropTypes.bool,
	onOk: PropTypes.func,
	onCancel: PropTypes.func,
};
